import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, OnDestroy } from '@angular/core';

@Directive({
    selector: '[dsIosActive]',
    standalone: true,
})
export class DsIosActiveSupportDirective implements OnDestroy {
    private readonly isIOS: boolean;

    constructor(
        private el: ElementRef<HTMLElement>,
        @Inject(DOCUMENT) private document: Document,
    ) {
        const win = this.document.defaultView;
        this.isIOS = !!win && /iPad|iPhone|iPod/.test(win.navigator.userAgent) && !('MSStream' in win);

        if (this.isIOS) {
            this.el.nativeElement.classList.add('ds-ios-active-fix');
        }
    }

    ngOnDestroy(): void {
        if (this.isIOS) {
            this.el.nativeElement.classList.remove('ds-ios-active-fix');
        }
    }
}
